module.exports = __webpack_public_path__ + "img/landing8.16dd8ef5.jpg";